import { ReviewType } from '@productsite-beta/src/graphql/generated/graphql-types'
import PlusIcon from '@dustin-web/microsite-components/src/icon/generated/plus'
import MinusIcon from '@dustin-web/microsite-components/src/icon/generated/minus'
import ArrowRightIcon from '@dustin-web/microsite-components/src/icon/generated/arrow-right'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import ReviewStars from '@dustin-web/product-components/src/review-stars'

type ProProps = {
  proReviews:
    | ({
        title?: string | null
        type: ReviewType
        cons?: string | null
        content?: string | null
        created: any
        domain?: string | null
        fullReviewUrl?: any | null
        pros?: string | null
        score: number
      } | null)[]
    | null
    | undefined
}

const ExpertReviews = ({ proReviews }: ProProps) => {
  const { translate } = useTranslations()

  const reviews = proReviews?.map((review, i, arr) => {
    const lastItem = i === arr?.length - 1
    if (review) {
      return (
        <article
          key={`${review.title}` + i}
          className={lastItem ? 'review-card--last' : 'review-card'}>
          <div className="review-card__expertFlexContainer">
            <section className="review-card__expertReviewInfoContainer">
              <header className="review-card__reviewInfo">
                <h3 className="review-card__title">{review.title}</h3>
                <div className="review-card__score">
                  <ReviewStars
                    reviewScore={review.score}
                    aria-label="Stars showing review rating"
                  />
                </div>
                <small className="review-card__sourceAndDate c-pipe-separator c-pipe-separator--compact">
                  <span>{review.domain}</span>
                  <time dateTime={review.created?.substring(0, 10)} aria-label="Review date">
                    {review.created?.substring(0, 10)}
                  </time>
                </small>
              </header>
              {review.fullReviewUrl ? (
                <footer>
                  <a
                    className="review-card__readFullReviewLg"
                    href={review.fullReviewUrl}
                    target="_blank"
                    rel="noreferrer">
                    <ArrowRightIcon
                      className="i-16 u-mr-8 u-relative"
                      aria-label="Arrow pointing right to a link"
                    />
                    <span className="u-fs-14" style={{ top: '-0.1rem' }}>
                      {translate('Product_Review_ReadFullReview', { domain: review.domain })}
                    </span>
                  </a>
                </footer>
              ) : null}
            </section>
            <section className="review-card__expertReviewContentContainer">
              <div className="review-card__expertContent">
                {review.content && <p>{review.content}</p>}
              </div>
              {review.pros && review.cons ? (
                <dl className="review-card__prosAndConsContainer">
                  <div className="review-card__prosContainer">
                    <dt className="review-card__pros u-color-dark-green">
                      <PlusIcon
                        className="i-16 u-mr-4 u-relative"
                        style={{ bottom: 1 }}
                        aria-label="Plus icon for pros"
                      />
                      <h4 className="h5 u-mb-0">{translate('Product_Review_Pros')}</h4>
                    </dt>
                    <dd className="p-sm">{review.pros}</dd>
                  </div>
                  <div className="review-card__consContainer">
                    <dt className="review-card__cons u-color-dark-red">
                      <MinusIcon
                        className="i-16 u-mr-4 u-relative"
                        style={{ bottom: 1 }}
                        aria-label="Minus icon for cons"
                      />
                      <h4 className="h5 u-mb-0">{translate('Product_Review_Cons')}</h4>
                    </dt>
                    <dd className="p-sm">{review.cons}</dd>
                  </div>
                </dl>
              ) : null}
              {review.fullReviewUrl ? (
                <footer>
                  <a
                    className="review-card__readFullReviewSm"
                    href={review.fullReviewUrl}
                    target="_blank"
                    rel="noreferrer">
                    <ArrowRightIcon
                      className="i-16 u-mr-8"
                      aria-label="Arrow pointing right to a link"
                    />
                    <span className="u-fs-14">
                      {translate('Product_Review_ReadFullReview', { domain: review.domain })}
                    </span>
                  </a>
                </footer>
              ) : null}
            </section>
          </div>
        </article>
      )
    }
  })
  return <>{reviews}</>
}

export default ExpertReviews
